export const selectiveExpansionEn = {
  loading: "Loading recommendations…",
  loadError: "Unable to load recommendations.",
  noRecommendations: "No recommendations match these filters.",
  noAssignments: "No store assignments.",
  pagination: "Recommendations pages",
  previousPage: "Previous page",
  nextPage: "Next page",
  recommendationsTable: "Selective Expansion recommendations",
  assignmentsTable: "Store assignments",
  expand: "Show store assignments",
  collapse: "Hide store assignments",
  category: "Category",
  rank: "Rank",
  itemCode: "Item code",
  itemName: "Item name",
  currentStores: "Current stores",
  recommendedStores: "Recommended stores",
  confidence: "Confidence",
  forecast: "7-day forecast opportunity",
  priorityScore: "Priority score",
  suppressionReason: "Suppression reason",
  store: "Store",
  item: "Item",
  eligible: "Eligible",
  yes: "Yes",
  no: "No",
  reasons: {
    sku_not_ranged: "SKU not ranged",
    sku_already_ranged: "SKU already ranged",
    pog_unresolved: "Planogram unresolved",
    upc_unmapped: "Item mapping unavailable",
    job_missing: "Store job missing",
    configured_exclusion: "Configured exclusion",
  },
};

export type SelectiveExpansionTranslations = typeof selectiveExpansionEn;
